import FormHeader from '../components/FormHeader';
import Select from '../components/Select';
import PrimaryButton from '../components/Submit';
import Text from '../components/Text';

type IProps = {
  onNext: () => void;
  currentIndex: number;
  totalSteps: number;
};

function EmploymentDetails(props: IProps) {
  return (
    <div className="form-container">
      <FormHeader title="Employment details" />
      <p className="helper-text">For regulatory purposes, we require same information on your employment status</p>
      <form action="#" method="POST" onSubmit={(e) => e.preventDefault()}>
        <Select
          label="Employment status"
          placeholder="Select your Employment Status"
          className="select-full"
          options={[
            { key: 'employed', value: 'Employed' },
            { key: 'self-employed', value: 'Self-Employed' },
            { key: 'retired', value: 'Retired' },
            { key: 'student', value: 'Student' },
            { key: 'unemployed', value: 'Unemployed' },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
        />

        <Text
          label="Registered business name"
          id="businessName"
          fullWidth={true}
          name="businessName"
          placeholder=""
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
        />

        <Select
          label="Industry"
          placeholder="Select your Industry"
          className="select-full"
          options={[
            { key: 'accountancy', value: 'Accountancy' },
            { key: 'finance', value: 'Finance' },
            { key: 'healthcare', value: 'Healthcare' },
            { key: 'education', value: 'Education' },
            { key: 'other', value: 'Other' },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
        />

        <PrimaryButton type="button" onClick={props.onNext} loading={false}>
          Next
        </PrimaryButton>
      </form>
    </div>
  );
}

export default EmploymentDetails;
